var tib = tib || {};
tib.blog = tib.blog || {};

tib.blog = (function($, /*templates*/ blogTemplates) {
    'use strict';
    var exports = {},
        _blogEntriesWithIds = {},
        _blogEntriesFormatted = {};

    exports.init = function() {
        Handlebars.registerHelper('if_even', function (conditional, options) {
            if ((conditional % 2) === 0) {
                return options.fn(this);
            } else {
                return options.inverse(this);
            }
        });
        exports.getAllBlogEntries();
        setupButtonClicks();
    };

    exports.getAllBlogEntries = function() {
        if (_blogEntriesFormatted.hasOwnProperty('BlogEntries')) {
            handleGetAllBlogEntriesFromExistingData(_blogEntriesFormatted);
        } else {
            $.ajax({
                url: '/api/blog',
                data:{
                    'action' : 'getAllBlogEntries'
                },
                type: 'POST'
            }).done(handleGetAllBlogEntries);
        }
    };

    exports.getAllBlogEntriesEvent = function(event) {
        //Предотвращаем стандартный переход по ссылке
        event.preventDefault();
        exports.getAllBlogEntries();
    };

    exports.getBlogEntryById = function(event) {
        //Предотвращаем стандартный переход по ссылке
        event.preventDefault();
        const blogEntryId = $(this).data('blog-entry-id');
        if (blogEntryId in _blogEntriesWithIds) {
            handleGetBlogEntryById(_blogEntriesWithIds[blogEntryId]);
        }
    };

    function handleGetAllBlogEntries(response) {
        if (response) {
            _blogEntriesFormatted = response;
            for (var i = 0; i < response['BlogEntries'].length; i++) {
                for (var j = 0; j < response['BlogEntries'][i].length; j++) {
                    _blogEntriesWithIds[response['BlogEntries'][i][j]['BlogEntryId']] = response['BlogEntries'][i][j];
                }
            }
            if (response.hasOwnProperty('LastBlogEntry')) {
                _blogEntriesWithIds[response['LastBlogEntry']['BlogEntryId']] = response['LastBlogEntry'];
            }
            $('.blog-block').html(blogTemplates['public/blog'](response));
        }
    }

    function handleGetAllBlogEntriesFromExistingData(data) {
        $('.blog-block').html(blogTemplates['public/blog'](data));
    }

    function handleGetBlogEntryById(response) {
        if (response) {
            let context = [];
            context['BlogEntry'] = response;
            $('.blog-block').html(blogTemplates['public/blog-entry'](context));
        }
    }

    function setupButtonClicks() {
        let body = $('body');
        body.on('click', '.blog-entry-link', exports.getBlogEntryById);
        body.on('click', '.blog-entry-full-link-back', exports.getAllBlogEntriesEvent);
    }

    return exports;
})(jQuery, tib.blogTemplate);

$(document).ready(function() {
    'use strict';
    tib.blog.init();
});